import { PatientCopay } from './copay.model';

export enum CollectionStatus {
  PortalPaidBalance = 'PB',
  PortalPaidBalanceAndCopay = 'PBER',
  PortalPaidCopay = 'PER',
  AgentCollectedBalance = 'ACB',
  AgentCollectedBalanceAndCopay = 'ACBER',
  AgentCollectedCopay = 'ACER',
  ThreeMonthsSplit = '3MS',
  BillPatient = 'BP',
  CollectionNeeded = 'CN',
  NoCollectionNeeded = 'NCN',
  Unknown = 'UNK',
}

// API Models

export interface ApiShipmentCollectionStatusResponse {
  patientId: number;
  shipmentId: number;
  collectionAmount: number;
  status: CollectionStatus;
  statusDate?: string;
}

export interface ApiShipmentCollectionStatusRequest extends ApiShipmentCollectionStatusResponse {}

// Front End Models

export interface ShipmentCollectionStatus extends ApiShipmentCollectionStatusResponse {}

// Mappers

export const mapCollectionStatus = (cs: ApiShipmentCollectionStatusResponse): ShipmentCollectionStatus => cs;

export const buildCollectionStatusRequest = (
  patientId: number,
  shipmentId: number,
  patientCopay: PatientCopay,
  isPaymentMade: boolean
): ApiShipmentCollectionStatusRequest => {
  let status = null;

  if (patientCopay.estimatedPatientResponsibility === 0) {
    status = CollectionStatus.NoCollectionNeeded;
  } else if (isPaymentMade) {
    if (patientCopay.excludeBalance || (!patientCopay.outstandingBalance && patientCopay.estimatedInsuranceCopayment)) {
      status = CollectionStatus.PortalPaidCopay;
    } else if (
      patientCopay.excludeCopay ||
      (patientCopay.outstandingBalance && !patientCopay.estimatedInsuranceCopayment)
    ) {
      status = CollectionStatus.PortalPaidBalance;
    } else {
      status = CollectionStatus.PortalPaidBalanceAndCopay;
    }
  } else {
    status = CollectionStatus.BillPatient;
  }

  return {
    patientId,
    shipmentId,
    status,
    collectionAmount: patientCopay.estimatedPatientResponsibility,
  };
};
